import { Schema } from "@/types/squidex";
import { PropsWithClassNameWithChildren } from "@/types/ui";
import type { VariantProps } from "class-variance-authority";
import React from "react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { Button, buttonVariants } from "@components/ui/button";
import { IconSquidex } from "@components/ui/icons/icon-squidex";
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip";
import { contentTools } from "@lib/content";

interface SquidexContentLinkProps
  extends PropsWithClassNameWithChildren, VariantProps<typeof buttonVariants> {
  content?: { readonly id?: string } & Schema;
  target?: HTMLLinkElement["target"];
  tooltip?: string;
}

export const SquidexContentLink = ({
  content,
  className,
  target,
  tooltip,
  children,
  ...props
}: SquidexContentLinkProps) => {
  const t = useTranslations("common.components.common.content.squidex.squidexContentLink");
  const contentLink = contentTools.getContentLink(content);

  if (!contentLink) return null;

  const onlyIcon = props.size?.includes("icon");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button asChild variant="outline" size="icon" className={className} {...props}>
          <Link href={contentLink} target={target ?? "_blank"}>
            <IconSquidex />
            {!onlyIcon && children}
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>{tooltip ?? t("tooltip")}</TooltipContent>
    </Tooltip>
  );
};
